import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { GasInputBoolean } from '@cikrf/gas-utils';

import { GasBaseMenuInterface, GasGroupMenuInterface, GasMenuType, GasMenySize } from '../gas-menu.interface';

@Component({
  selector: 'gas-vertical-menu',
  templateUrl: './gas-vertical-menu.component.html',
  styleUrls: [
    './gas-vertical-menu.component.scss',
    './vertical-menu-styles/light-menu.scss',
    './vertical-menu-styles/base-menu.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasVerticalMenuComponent implements OnInit {
  @HostBinding('class._large')
  public get largeSize(): boolean {
    return this.size === 'large';
  }
  @HostBinding('class._small')
  public get smallSize(): boolean {
    return this.size === 'small';
  }
  @HostBinding('class._base')
  public get baseType(): boolean {
    return this.type === 'base';
  }
  @HostBinding('class._light')
  public get lightType(): boolean {
    return this.type === 'light';
  }

  /** возвращает объект пункта меню */
  @Output('onMenuClicked')
  public onMenuClicked$: EventEmitter<GasBaseMenuInterface> = new EventEmitter<GasBaseMenuInterface>(null);

  /** Заголовок для меню */
  @Input()
  public title: string;

  /** Массив с элементами меню */
  @Input()
  public menu: GasBaseMenuInterface[] = [];

  @Input()
  public groupMenu: GasGroupMenuInterface[] = [];

  /** Размер элемента меню */
  @Input()
  public size: GasMenySize | string = 'large';

  /** внешний вид элементов меню */
  @Input()
  public type: GasMenuType = 'base';

  /** добавляет иконку галки для выбранного пункта меню */
  @GasInputBoolean()
  @Input('selectedIcon')
  public isSelectedIcon: string | boolean = false;

  /** иконка слева от текста */
  @Input()
  public suffixIcon: string;

  /** иконка справа от текста */
  @Input()
  public postfixIcon: string;

  public ngOnInit(): void {
    let link: GasBaseMenuInterface;
    if (this.groupMenu.length) {
      this.groupMenu.forEach(menu => menu.links.forEach(item => {
        if (item.active) {
          link = item;
        }
      }));
    } else {
      this.menu.forEach(item => {
        if (item.active) {
          link = item;
        }
      });
    }

    if (link) {
      this.changeLink(link);
    }
  }

  /** Обработка клика по пункту меню и эмитт этого пункта наверх */
  public changeLink(link: GasBaseMenuInterface): void {
    if (link.disable) {
      return;
    }

    if (this.menu.length) {
      this.menu.forEach(item => item.active = false);
    }
    if (this.groupMenu.length) {
      this.groupMenu.forEach(menu => menu.links.forEach(item => {
        item.active = false;
      }));
    }

    link.active = true;
    this.onMenuClicked$.emit(link);
  }
}
